import { render, staticRenderFns } from "./CommitteeForm.vue?vue&type=template&id=5167c1f3"
import script from "./CommitteeForm.vue?vue&type=script&lang=ts"
export * from "./CommitteeForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports